export default {
  get: `query getUser($email: String!) {
          getUser(email: $email) {
            id,
            name,
            email,
            office,
            role,
            isFirstLogged,
            officeInfo {
              id
              name
              notesLink
              closeDate
              startDate
              country
            },
            dietsInfo {
              id
              name
            },
            allergiesInfo {
              id
            },
          }
        }`,
};



// WEBPACK FOOTER //
// ./src/graphql/queries/user.js